import { useEffect, useRef, useState } from "react";


export const useTableColumnCount = () => {
  const tableRef = useRef<HTMLTableElement>(null);
  const [columnCount, setColumnCount] = useState<number>(0);

  useEffect(() => {
    if (tableRef.current) {
      const headerCells = tableRef.current.querySelectorAll("thead th");
      setColumnCount(headerCells.length);
    }
  }, []);

  return { tableRef, columnCount };
};
